import React from 'react';
import { Smartphone } from 'lucide-react';
import StoreButtons from './StoreButtons';
import '../../styles/app-download.css';

/**
 * Sección de descarga de la app móvil SOEM (Home).
 * Los botones y sus URLs viven en StoreButtons, que también usa la página
 * de Contacto — así no hay dos copias del enlace que se desincronicen.
 */
const AppDownload = () => (
  <section className="section app-download" id="descargar">
    <div className="container">
      <div className="app-download-card">
        <div className="app-download-icon" aria-hidden="true">
          <Smartphone size={28} />
        </div>

        <h2 className="app-download-title">Lleve la evaluación al sitio</h2>
        <p className="app-download-subtitle">
          La aplicación SOEM permite levantar la evaluación directamente en el
          recinto —con evidencia fotográfica, video y notas de voz— y funciona
          sin conexión: la información se sincroniza sola al recuperar señal.
        </p>

        <StoreButtons />

        <p className="app-download-note">
          Gratuita · iPhone (iOS 15.1 o posterior) y Android · El acceso a la
          plataforma se otorga por SOEM Partners Group
        </p>
      </div>
    </div>
  </section>
);

export default AppDownload;
